import { render, staticRenderFns } from "./create_artwork.vue?vue&type=template&id=226d06ba"
import script from "./create_artwork.vue?vue&type=script&lang=js"
export * from "./create_artwork.vue?vue&type=script&lang=js"
import style0 from "./create_artwork.vue?vue&type=style&index=0&id=226d06ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports